import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { inputBaseClasses, formLabelClasses, inputLabelClasses, formControlClasses, TextField } from '@mui/material';
import '@babel/runtime/helpers/toConsumableArray';
import { useSafeId } from '../../hooks/useSafeId/useSafeId.hook.js';

var _staticTextFieldRoot;

var styles = {
  staticTextFieldRoot: (_staticTextFieldRoot = {}, _defineProperty(_staticTextFieldRoot, "& .".concat(inputBaseClasses['input'], ".").concat(inputBaseClasses['disabled']), {
    color: 'text.primary',
    fontWeight: 'fontWeightMedium',
    fontSize: 'body1.fontSize',
    '-webkit-text-fill-color': 'initial'
  }), _defineProperty(_staticTextFieldRoot, "& .".concat(formLabelClasses['root'], ".").concat(inputLabelClasses['root']), {
    color: 'text.secondary',
    fontWeight: 'fontWeightMedium',
    fontSize: 'overline.fontSize'
  }), _defineProperty(_staticTextFieldRoot, "&.".concat(formControlClasses['marginDense'], " >label"), {
    transform: 'translate(12px, 25px) scale(0.85)'
  }), _defineProperty(_staticTextFieldRoot, "maxHeight", '3rem'), _defineProperty(_staticTextFieldRoot, "& >div.".concat(inputBaseClasses['root']), {
    maxHeight: '3rem',
    margin: 0
  }), _staticTextFieldRoot)
};

var StaticTextField = function StaticTextField(_ref) {
  var label = _ref.label,
      margin = _ref.margin,
      fullWidth = _ref.fullWidth,
      value = _ref.value,
      classes = _ref.classes,
      id = _ref.id,
      sx = _ref.sx;
  var staticTextFieldRoot = styles.staticTextFieldRoot;
  var safeId = useSafeId(id);
  return /*#__PURE__*/React.createElement(TextField, {
    sx: [staticTextFieldRoot, sx],
    variant: "standard",
    label: label,
    margin: margin,
    fullWidth: fullWidth,
    classes: classes,
    value: value,
    "aria-label": label,
    InputProps: {
      disableUnderline: true
    },
    disabled: true,
    id: safeId
  });
};

StaticTextField.defaultProps = {
  margin: 'normal',
  fullWidth: true,
  label: ''
};
StaticTextField.displayName = 'StaticTextField';
export { StaticTextField };